import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';
import PageTitle from '../../components/PageTitle';
import { dateFormatter } from '../../helpers/datehelper';
import { fetchJSON, postJSON } from '../../helpers/api';
import Spinner from '../../components/Spinner';
import GenericTable from '../../components/GenericTable';

import { setActivePage } from "../../redux/appMenu/actions";

class AssetsForSaleListings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userAcceptanceCheckComplete: false, userAcceptedA4SAgreement: false, extranetAgreementId: 0, a4STermsText: '', a4sTermsLoading: false,
            listingsData: [], loading: true, showOptOutModal: false, listingId: 0, listingName: '', showDeRegisterModal: false, error: false
        };

        this.checkIfUserAcceptedA4SAgreement = this.checkIfUserAcceptedA4SAgreement.bind(this);
        this.loadAssetsForSaleListings = this.loadAssetsForSaleListings.bind(this);
        this.toggleOptOutModal = this.toggleOptOutModal.bind(this);
        this.optUserOutOfListing = this.optUserOutOfListing.bind(this);
        this.acceptA4SAgreement = this.acceptA4SAgreement.bind(this);
        this.rejectA4SAgreement = this.rejectA4SAgreement.bind(this);
        this.toggleDeRegisterModal = this.toggleDeRegisterModal.bind(this);
        this.deRegisterFromService = this.deRegisterFromService.bind(this);
        this.loadA4STermsOfUse = this.loadA4STermsOfUse.bind(this);
    }

    componentDidMount = () => {
        this.props.setActivePage();
        this.checkIfUserAcceptedA4SAgreement();
    }

    async checkIfUserAcceptedA4SAgreement() {
        if (!this.state.error) {
            let url = `/portal/AssetForSale/CheckIfUserAcceptedA4STerms`;
            let response = await fetchJSON(url);
            if (!response.error) {
                this.setState({ userAcceptedA4SAgreement: response.data, userAcceptanceCheckComplete: true, error: response.error });
                if (response.data) {
                    this.loadAssetsForSaleListings();
                }
                else {
                    this.loadA4STermsOfUse();
                }
            } else {
                this.setState({ userAcceptedA4SAgreement: true, userAcceptanceCheckComplete: true, error: response.error, listingsData: [], loading: false });
            }
        }
    }

    async loadA4STermsOfUse() {
        let url = `/portal/AssetForSale/GetA4STerms`;
        let response = await fetchJSON(url);
        this.setState({ extranetAgreementId: response.data.extranetAgreementId, a4STermsText: response.data.extranetAgreementText, a4sTermsLoading: response.loading, error: response.error });
    }

    async loadAssetsForSaleListings() {
        if (!this.state.error) {
            let url = `/portal/AssetForSale/GetListings`;
            let response = await fetchJSON(url);
            this.setState({ listingsData: response.data, loading: response.loading, error: response.error });
        }
    }

    toggleOptOutModal = (listingId, listingName) => {
        this.setState({ listingId: listingId, listingName: listingName })
        this.setState(prevState => ({ showOptOutModal: !prevState.showOptOutModal }));
    };

    async optUserOutOfListing() {
        let url = `/portal/AssetForSale/OptOutOfListing?listingId=${this.state.listingId}`;
        let response = await postJSON(url);
        if (response.data && !response.error) {
            this.loadAssetsForSaleListings();
            this.setState(prevState => ({ showOptOutModal: !prevState.showOptOutModal }));
        }
        else {
            this.setState({ error: response.error });
        }
    };

    async acceptA4SAgreement(extranetAgreementId) {
        let url = `/portal/AssetForSale/SaveAgreementAcceptance?extranetAgreementId=${extranetAgreementId}`;
        let response = await postJSON(url);
        if (!response.error) {
            this.setState({ userAcceptedA4SAgreement: true })
            this.loadAssetsForSaleListings();
        } else {
            this.setState({ error: response.error });
        }
    };

    async rejectA4SAgreement() {
        window.location.href = "/portal/Dashboard";
    };

    toggleDeRegisterModal = () => {
        this.setState(prevState => ({
            showDeRegisterModal: !prevState.showDeRegisterModal,
        }));
    };

    async deRegisterFromService() {
        let url = `/portal/AssetForSale/DeRegisterFromAssetForSale`;
        let response = await postJSON(url);
        if (response.data) {
            this.toggleDeRegisterModal();
            window.location.href = "/portal/Dashboard";
        } else {
            this.toggleDeRegisterModal();
            this.setState({ error: response.error });
        }
    };

    columnClicked = (columnIndex, listingId, listingName, dealType, acceptedNDA) => {
        if (columnIndex !== 8) {
            if (dealType != null && dealType.toUpperCase() === 'WITH LEASE' && !acceptedNDA) {
                this.props.history.push({
                    pathname: "NDADisplay",
                    state: { selectedListingId: listingId, selectedListingName: listingName, selectedListingDealType: dealType }
                });
            }
            else {
                this.props.history.push({
                    pathname: "Details",
                    state: { selectedListingId: listingId }
                });
            }
        }
    }

    render() {
        const optOutColumn = (cell, row, rowIndex, extraData) => {
            return (
                <Button className="btn-icon" color="primary" onClick={() => { this.toggleOptOutModal(row.listingId, row.listingName) }}><i className="dripicons-thumbs-down"></i></Button>
            );
        }

        const openListingDetails = (cell, row, rowIndex, extraData) => {
            return (<i className="mdi mdi-arrow-right-bold-circle-outline mdi-18px"></i>);
        }

        const columns = [
            {
                isDummyField: true,
                dataField: 'df1',
                text: '',
                sort: false,
                formatter: openListingDetails,
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                }
            },
            {
                dataField: 'listingName',
                text: 'Listing Name',
                sort: true,
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                }
            },
            {
                dataField: 'numberOfAssets',
                text: 'No. of Assets',
                sort: true,
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                }
            },
            {
                dataField: 'dealType',
                text: 'Deal Type',
                sort: true,
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                }
            },
            {
                dataField: 'location',
                text: 'Location',
                sort: true,
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                }
            },
            {
                dataField: 'currentBidRoundName',
                text: 'Current Bid Round',
                sort: true,
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                }
            },
            {
                dataField: 'closingDate',
                text: 'Closing Date',
                sort: true,
                style: { whiteSpace: 'nowrap' },
                headerStyle: { whiteSpace: 'nowrap' },
                formatter: function (cellValue) {
                    return dateFormatter(cellValue);
                },
                csvFormatter: function (cellValue) {
                    return dateFormatter(cellValue);
                },
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                }
            },
            {
                dataField: 'daysLeft',
                text: 'Days Left',
                sort: true,
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                }
            },
            {
                isDummyField: true,
                dataField: 'optOut',
                text: 'Opt Out',
                formatter: optOutColumn,
                headerClasses: 'optOutColumn',
                classes: 'optOutColumn',
                events: {
                    onClick: (e, column, columnIndex, row, rowIndex) => {
                        this.columnClicked(columnIndex, row.listingId, row.listingName, row.dealType, row.acceptedNDA);
                    }
                },
                csvExport: false
            }
        ];

        const defaultSorted = [
            {
                dataField: 'closingDate',
                order: 'asc',
            },
        ];

        if (this.state.userAcceptanceCheckComplete && !this.state.error) {
            if (this.state.userAcceptedA4SAgreement) {
                return (
                    <React.Fragment>
                        <PageTitle
                            breadCrumbItems={[
                                { label: 'Asset for Sale', path: '/AssetForSale/Index', active: true },
                            ]}
                            title={'Asset for Sale'}
                            error={this.state.error}
                        />
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <GenericTable
                                            columns={columns}
                                            data={this.state.listingsData}
                                            keyField='listingId'
                                            defaultSorted={defaultSorted}
                                            loading={this.state.loading}
                                            exportButtonName='Listings'
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={10}>
                                <Button color="secondary" onClick={() => { this.toggleDeRegisterModal() }}>De-Register From Service</Button>
                            </Col>
                        </Row>

                        <Modal
                            isOpen={this.state.showOptOutModal}
                            toggle={this.toggleOptOutModal}
                            size={'lg'}>
                            <ModalHeader toggle={this.toggleOptOutModal}>Opt Out of Listing</ModalHeader>
                            <ModalBody className={this.state.bodyClass}>
                                <p>You have chosen to "Opt Out" of the listing - <strong>{this.state.listingName}</strong>. This means:</p>
                                <p> - You will no longer be able to view the details of the listing.</p>
                                <p> - You will not receive information about updates to the listing.</p>
                                <p>Please confirm that you would like to "Opt Out" of the listing.</p>
                            </ModalBody>
                            <ModalFooter className={this.state.bodyClass}>
                                <Button color="secondary" onClick={this.optUserOutOfListing}>Confirm</Button>
                                <Button color="primary" onClick={this.toggleOptOutModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>

                        <Modal
                            isOpen={this.state.showDeRegisterModal}
                            toggle={this.toggleDeRegisterModal}
                            size={'lg'}>
                            <ModalHeader toggle={this.toggleDeRegisterModal}>De-Register from Asset for Sale</ModalHeader>
                            <ModalBody>
                                <p>You have chosen to "De-Register" from the Asset For Sale service. This means:</p>
                                <p> - You will no longer be able to view the details of listings you are currently invited to.</p>
                                <p> - You will not receive information about updates to listings which you are currently invited to.</p>
                                <p> - You may not be invited to future Asset For Sale listings.</p>
                                <p>Please confirm that you would like to "De-Register" from the Asset for Sale service.</p>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.deRegisterFromService}>Confirm</Button>
                                <Button color="primary" onClick={this.toggleDeRegisterModal}>Cancel</Button>
                            </ModalFooter>
                        </Modal>
                    </React.Fragment>
                );
            }
            else {
                return (
                    <React.Fragment>
                        <PageTitle
                            breadCrumbItems={[
                                { label: 'Asset for Sale', path: '/AssetForSale/Index', active: true },
                            ]}
                            title={'Asset for Sale - Terms and Conditions'}
                            error={this.state.error}
                        />
                        {!this.state.a4sTermsLoading && !this.state.error &&
                            <React.Fragment>
                                <div dangerouslySetInnerHTML={{ __html: this.state.a4STermsText }} />
                                <div className="a4sTermsAndConditionsButtons">
                                    <Button color='primary' onClick={() => { this.acceptA4SAgreement(this.state.extranetAgreementId) }}>Accept</Button>{' '}<Button style={{ marginLeft: 1 + 'em' }} color='secondary' onClick={this.rejectA4SAgreement}>Reject</Button>{' '}
                                </div>
                            </React.Fragment>
                        }
                    </React.Fragment>
                );
            }
        } else {
            return (
                <React.Fragment>
                    <PageTitle
                        breadCrumbItems={[
                            { label: 'Asset for Sale', path: '/AssetForSale/Index', active: true },
                        ]}
                        title={'Asset for Sale'}
                        error={this.state.error}
                    />
                    {!this.state.error && <Spinner className="checkingSpinner" color="success" size="sm" />}
                </React.Fragment>
            );
        }
    }
}

class AssetForSalePrivacyModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
        }));
    };

    render() {
        return (
            <React.Fragment>
                <Button className="float-right" color="link" onClick={this.toggle}>View Privacy Policy ...</Button>

                <Modal
                    isOpen={this.state.showModal}
                    toggle={this.toggle}
                    size={'lg'}>
                    <ModalHeader toggle={this.toggle}>Asset for Sale Privacy Policy</ModalHeader>
                    <ModalBody className={this.state.bodyClass}>
                        <p>
                            AerCap is the commercial operator of this Site, although software, hosting and other functions and content may be provided by AerCap's service providers ("Service Providers"), AerCap's affiliates ("Affiliates"), or companies in a business relationship with AerCap ("Business Partners"). This Site is not directed to or intended for individuals under 18 years of age.
							<br />
                            <br />
                            This Policy describes the types of information AerCap and its Affiliates, Business Partners, and Service Providers collect from visitors to the Site, what we do with this information, and how visitors can update and control the use of information they provide on the Site. This Policy applies solely to information that visitors provide through our Site and the Service provided on the Site. This Policy does not apply to other data we collect, including data collected on other sites, such as separate sites operated by our Affiliates or Business Partners, or information you may provide to us through e-mail or other means.
							<br />
                            <br />
                            Protecting your privacy is very important to us. Our goal is to treat the personal information you furnish to us through this Site with respect and in accordance with this Policy.
							<br />
                            <br />
                            INFORMATION WE COLLECT AND HOW WE USE IT
							<br />
                            You can visit our Site without revealing any personal information about yourself, but you will not have access to the listings provided on our Site unless you have a AerCap extranet account and you register on our Site.  To register, you must accurately provide your name, company affiliation, title, address, telephone number, and email address.  If you choose to do so, we use the information to:
							<br />
                            <ul type="disc">
                                <br />
                                <li>Provide you with information about and access to listings from the Site;</li>
                                <br />
                                <li>Inform you about other products or services in which you might be interested;</li>
                                <br />
                                <li>Notify you about changes in our Site or services; and</li>
                                <br />
                                <li>Improve our services.</li>
                            </ul>
                            <br />
                            You also may elect to request additional products or services through our Site, which may require us to gather additional information to determine your eligibility for such products or services.  If you choose to contact us through the "Contact Us" feature on the Site, you may also provide us with personal information.  We will use that information to respond to your inquiry.
							<br />
                            <br />
                            Please note that we do not knowingly solicit information from children under 18 years of age and we do not knowingly market our products or services to such children.
							<br />
                            <br />
                            INFORMATION WE COLLECT BY AUTOMATED MEANS
							<br />
                            When you visit our Site, our Web servers collect the name of the domain you used to access the Internet (such as aol.com), which pages on our Site you visited and when they were visited, your Internet browser type and platform, the link that brought you to our Site and any links clicked within our Site.  This information may be used by us, our Service Providers, Affiliates and Business Partners to measure the number of visits, average time spent, page views and other statistics about visitors to our Site.  We also use that data to monitor Site performance and make the Site easier and more convenient to use.
							<br />
                            <br />
                            Cookies
							<br />
                            Cookies are small pieces of data stored by your Internet browser on your computer's hard drive.  If you visit our Site, a cookie is used to help us measure the number of visits, average time spent, page views and other statistics relating to our Site.  This cookie by itself does not tell us your e-mail address or who you are.  If you decide to register online or request information, products or services from us, we may collect additional information to provide tailored offerings or content to you or to deliver such products and services.  In this case, we use cookies to allow us to recognize you on subsequent visits, enhance your online experience and make our provision of services more efficient.
							<br />
                            <br />
                            Our cookies are not used to get data from your hard drive or get your e-mail address.  You may set your Internet browser to notify you when you receive a cookie or to prevent cookies from being sent.  Please note, however, that by not accepting cookies, you may limit the functionality we can provide you when you visit our Site and your ability to access certain services we offer.
							<br />
                            <br />
                            Some of our Affiliates and Business Partners may use cookies on our Site (for example, advertisers).  However, we have no access to or control over these cookies once we have given permission for these third parties to set cookies for advertising.  This Policy covers the use of cookies by AerCap only and does not cover the use of cookies by our Affiliates or Business Partners.
							<br />
                            <br />
                            INFORMATION WE SHARE
							<br />
                            When you provide information to us through our Site, we may share your information with Service Providers we have retained to perform services on our behalf.  These Service Providers are not authorized by us to use or disclose the information except as necessary to perform services on our behalf or comply with legal requirements.  We also may share your information with our Affiliates and Business Partners to provide you with the services you have requested,  and improve, develop, inform you about, and offer you our products and services.  You hereby acknowledge and provide your consent to the AerCap to transfer and store your personal information across national boundaries for any purpose described in this Policy.  We also may disclose your information:  (i) if we are required or permitted to do so by law or legal process; (ii) to law enforcement authorities; or (iii) when we believe disclosure is necessary or appropriate to prevent physical harm or financial loss or in connection with an investigation of suspected or actual illegal activity.
							<br />
                            <br />
                            We also may aggregate statistics that we gather about our customers, traffic patterns, and services and provide these statistics to our Service Providers, Affiliates and Business Partners in aggregate form.  These statistics do not contain any personal information.
							<br />
                            <br />
                            We reserve the right to transfer any information we have about you in the event that all or part of AerCap or all or part of its assets are acquired by, merged with, sold to, or otherwise disposed of to one or more third parties (including, without limitation, in the event of bankruptcy).
							<br />
                            <br />
                            YOUR CHOICES
							<br />
                            If you submit information to us during your visit to our Site, you can direct us not to share this information with our Business Partners (except as described in the preceding section) by e-mailing us at AssetForSale@AerCap.com (use the subject line "DISCLOSURE OPT-OUT" and include your name, physical address and e-mail address) or by calling the telephone number listed on the Contact Us page of our Site.  You may not opt-out of the sharing of your information as described in the preceding section.
							<br />
                            <br />
                            If you are a California resident, you may ask us to refrain from sharing your personal information (whether collected online or offline) with our Affiliates (if the Affiliates are separate legal entities) or Business Partners for their own marketing purposes.  Please tell us your preference by e-mailing us at AssetForSale@AerCap.com (use the subject line "CALIFORNIA DISCLOSURE OPT-OUT" and include your name, physical address and e-mail address) or by calling the telephone number listed on the Contact Us page of our Site.
							<br />
                            <br />
                            E-MAIL COMMUNICATION AND ONLINE SURVEYS
							<br />
                            As part of the Service offered on our Site, we will send you e-mail communications about GE assets available for sale that are advertised in our listings.  Occasionally, we may also send you e-mail communications with information about other GE products and services or about offerings from our Affiliates or Business Partners.  When you first provide us with your e-mail address, you will be given the choice to direct us not to send you marketing communications.  We will also include instructions in our e-mail messages on how to unsubscribe if you later decide you do not want to receive any future marketing communications from us or from our Affiliates or Business Partners.
							<br />
                            <br />
                            You can stop receiving e-mails about a particular listing by sending an e-mail to AssetForSale@AerCap.com.  You can opt-out of receiving all e-mails about our listings by canceling your registration on our Site.  If you cancel your registration, you will be unable to receive notice about the availability of, or access to, the listings on our Site.
							<br />
                            <br />
                            At times, we conduct online surveys to better understand the needs, profiles and experience of our visitors.  You will be given the option of not participating in such surveys.
							<br />
                            <br />
                            ACCESSING AND UPDATING YOUR INFORMATION
							<br />
                            If you register on our Site or otherwise provide us with personal information or other commercial or financial information through the Site, you may update the information you submit by emailing us at AssetForSale@AerCap.com.
							<br />
                            <br />
                            HOW WE PROTECT PERSONAL INFORMATION
							<br />
                            Our goal is to protect your personal information submitted to us through this Site.  We maintain reasonable administrative, technical and physical safeguards to protect against loss, misuse or unauthorized access, disclosure, alteration or destruction of the information you provide on our Site.  We instruct our employees with access to your personal information that it must be used only in adherence with the principles set forth in this Policy and applicable laws.  Employees who misuse customer information are subject to disciplinary action.
							<br />
                            <br />
                            Please note that information you send us electronically is not necessarily secure when it is transmitted to us.  We suggest that you do not use unsecured electronic methods to communicate with us if your communication is very sensitive or includes highly confidential information.
							<br />
                            <br />
                            Finally, no security measures, however thorough, are perfect.  Accordingly, we do not guarantee the security of the information you provide to us.
							<br />
                            <br />
                            OTHER INFORMATION COLLECTORS
							<br />
                            This Policy only applies to the use and disclosure of information we collect through this Site.  Our Site may include links to the sites of our Affiliates, Business Partners or others.  The privacy practices or policies of those sites may be different from ours.  Information you disclose to other parties or through such sites is subject to the privacy practices and policies of those parties or sites.  We are not responsible for the content, privacy practices or your use of those linked sites.
							<br />
                            <br />
                            INTERNATIONAL USERS
							<br />
                            This Site is intended primarily for visitors from the United States and it is provided in accordance with and subject to applicable U.S. law.  If you decide to continue to access this Site from your location outside the United States, you hereby agree that your use of this Site is subject to this Policy.
							<br />
                            <br />
                            CHANGES TO OUR PRIVACY POLICY
							<br />
                            We reserve the right to modify or supplement this Policy at any time and without prior notice to you.  If we make any material change to the Policy, we will update our Site to include such changes.  We recommend that you review this Policy regularly for changes.
							<br />
                            <br />
                            CONTACT
							<br />
                            To contact us, please send an e-mail message to AssetForSale@AerCap.com.  To ask a question about a listing on our site, please contact the Marketing contact identified on the listing.
							<br />
                            <br />
                            Last updated:   January 23, 2012
                        </p>
                    </ModalBody>
                    <ModalFooter className={this.state.bodyClass}>
                        <Button color="primary" onClick={this.toggle}>Close</Button>{' '}
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setActivePage: () => {
            dispatch(setActivePage("AssetForSale"));
        }
    };
}
export default connect(null, mapDispatchToProps)(AssetsForSaleListings);
